var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"containe"},[_c('div',{staticClass:"titleIcon"},[(_vm.iconUrl)?_c('img',{staticClass:"icon",attrs:{"src":_vm.iconUrl}}):_vm._e()]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }